export type ProjectRole = 'Owner' | 'Maintainer' | 'Collaborator' | 'Viewer';

export const PROJECT_ROLES: ProjectRole[] = [
  'Owner',
  'Maintainer',
  'Collaborator',
  'Viewer',
];

export const ASSIGNABLE_PROJECT_ROLES = PROJECT_ROLES.filter(
  role => role !== 'Owner',
);

export type ProjectAction =
  | 'work-item.write'
  | 'work-item.approve'
  | 'project.artifacts.manage'
  | 'project.settings'
  | 'project.invite'
  | 'project.delete'
  | 'project.ownership-transfer';
